import { BaseTable, Loading, TableHeader } from "components";
import { useListDataPost } from "../../utils";
import { RejectType } from "pages/Card/Transaction/CreateNewVendor/types";
import moment from "moment";
import { APPROVAL, convertNumber } from "utils";

export function Reject(props: {
    dateFrom: string
    dateTo: string
    approval?: string
    vendorId: number
    bill?: string
}) {

    const { data, isLoading } = useListDataPost<RejectType>("reject", {
        DateFrom: props.dateFrom,
        DateEnd: props.dateTo,
        Approval: props.approval,
        VendorID: props.vendorId,
        bill: props.bill
    })

    const totalQtyRejected = data.reduce((acc, item) => acc + item.qty, 0)
    const totalQtyReceived = data.reduce((acc, item) => acc + item.qty_received, 0)
    const totalBackRejected = data.reduce((acc, item) => acc + item.back_rejected, 0)

    return (
        <div>
            <div className="overflow-x-auto mt-12">
                <BaseTable className="border-collapse">
                    <TableHeader>
                        <tr>
                            <th>NO</th>
                            <th>REJECT ID</th>
                            <th>BILL ID</th>
                            <th>DATE</th>
                            <th>APPROVAL</th>
                            <th>QTY REJECTED</th>
                            <th>QTY RECEIVED</th>
                            <th>BACK REJECTED</th>
                        </tr>
                    </TableHeader>
                    <tbody>
                        {isLoading || !data.length ? (
                            <tr>
                                <td colSpan={7}>
                                    <div className="w-full flex justify-center items-center">
                                        <Loading loading={isLoading} errorText={isLoading ? "" : "No data available"} />
                                    </div>
                                </td>
                            </tr>
                        ) : (
                            data.map((item, index: number) => {
                                return (
                                    <tr key={index}>
                                        <td>{index + 1}</td>
                                        <td>{item.trx_code}</td>
                                        <td>{item.trx_bill_code}</td>
                                        <td>{item.transaction_date ? moment(item.transaction_date).format("DD/MM/YYYY") : ""}</td>
                                        <td>{APPROVAL[item.approve_status]}</td>
                                        <td>{item.qty ? convertNumber(item.qty).intoNormalAmount : ""}</td>
                                        <td>{item.qty_received ? convertNumber(item.qty_received).intoNormalAmount : ""}</td>
                                        <td>{item.back_rejected ? convertNumber(item.back_rejected).intoNormalAmount : ""}</td>
                                    </tr>
                                )
                            }
                            )
                        )}
                    </tbody>
                </BaseTable>
            </div>
            <div className="mt-2 flex justify-end font-bold">
                <div className="flex flex-col gap-2">
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Rejected</span>
                        <span>:</span>
                        <span className="text-right ml-2">{ totalQtyRejected ? convertNumber(totalQtyRejected).intoNormalAmount : ""}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Received</span>
                        <span>:</span>
                        <span className="text-right ml-2">{ totalQtyReceived ? convertNumber(totalQtyReceived).intoNormalAmount : ""}</span>
                    </div>
                    <div className="flex">
                        <span className="mr-2 w-[150px]">Total Back Rejected</span>
                        <span>:</span>
                        <span className="text-right ml-2"> { totalBackRejected ? convertNumber(totalBackRejected).intoNormalAmount : ""}</span>
                    </div>
                </div>
            </div>
        </div>
    )
}